// Ref-counted scroll lock shared by modals / mobile menu.
// Guarantees Lenis + body overflow are only locked while at least one
// lock holder is active, and can always be force-reset.
let count = 0;

const apply = () => {
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (count > 0) {
    lenis?.stop?.();
    document.body.style.overflow = "hidden";
  } else {
    lenis?.start?.();
    document.body.style.overflow = "";
    document.documentElement.classList.remove("lenis-stopped");
  }
};

export function lockScroll() {
  count += 1;
  apply();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    count = Math.max(0, count - 1);
    apply();
  };
}

export function resetScrollLock() {
  count = 0;
  apply();
}

export function isScrollLocked() {
  return count > 0;
}
